<div class="header">
    <h2>{{ heading }}</h2>
    <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
  </div>
  
  <mat-dialog-content style="min-height: 80%">
    <!-- <div class="search-box">
      <input matInput placeholder="Search" [(ngModel)]="searchitem" />
    </div> -->
    <div style="  color: grey;
  margin-left: 1%;" *ngIf="itemlistArray.length==0" >No data to show at this moment</div>
  
    <mat-list *ngIf="data.fromwhere=='selecttechnician'">
      <mat-list-item 
        *ngFor="let item of itemlistArray | search: { name: searchitem }"
        (click)="selectItem(item)">
        <mat-checkbox
          *ngIf="isMultiple"
          [checked]="isSelected(item)"
          (change)="toggleSelection(item)"
          >{{ item.name }}</mat-checkbox
        >
        <div 
          mat-line
          *ngIf="!isMultiple"
       
     
        >
          {{ item.name }}
        </div>
      </mat-list-item>
    </mat-list>


      
    <mat-list *ngIf="data.fromwhere=='selectvehicle'">
      <mat-list-item 
        *ngFor="let item of itemlistArray | search: { name: searchitem }"
        (click)="selectItem(item)">
        <mat-checkbox
          *ngIf="isMultiple"
          [checked]="isSelected(item)"
          (change)="toggleSelection(item)"
          >{{ item.vehiclename }}</mat-checkbox
        >
        <div 
          mat-line
          *ngIf="!isMultiple"
       
     
        >
          {{ item.vehiclename }}
        </div>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <!-- <button mat-button (click)="toggleSelectionMode()">
      Switch to {{ isMultiple ? 'Single' : 'Multiple' }} Selection
    </button> -->
    <button mat-button mat-dialog-close class="btn close-btn" style="font-size: 12px;background-color:#6c757d;color:white">Close</button>
  </mat-dialog-actions>
  